export const USER_UPDATE = "USER_UPDATE";

export const userUpdate = (data) => (dispatch) => {
  dispatch({
    type: USER_UPDATE,
    payload: data,
  });
};
